import Square from './square'

const integrations = {}
integrations[Square.guid] = Square

export default integrations
